// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormIcon_wrapper__TxBQm","load":"FormIcon_load__ODodt"};